import { ApolloClient, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { createUploadLink } from 'apollo-upload-client';

// Create upload link for GraphQL endpoint with file upload support
const uploadLink = createUploadLink({
  uri: process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/graphql` : 'http://localhost:8000/graphql',
});

// Auth link for adding authentication headers if needed
const authLink = setContext((_, { headers }) => {
  // Get authentication token from localStorage if it exists
  const token = localStorage.getItem('authToken');

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
      'X-Trio-Client': 'web',
    }
  };
});

// Normalized cache with type policies for entity deduplication.
// Types with keyFields: ['id'] are stored once in the cache regardless of
// which query returned them. Mutation results that include __typename + id
// automatically update all queries referencing that entity.
const cache = new InMemoryCache({
  typePolicies: {
    // Core entities — normalize by id
    InvoiceDetailType:       { keyFields: ['id'] },
    InvoiceListItemType:     { keyFields: ['id'] },
    InvoiceLineItemType:     { keyFields: ['id'] },
    InvoiceSubmissionType:   { keyFields: ['id'] },
    ActivityType:            { keyFields: ['id'] },
    ActivityListItemType:    { keyFields: ['id'] },
    ActivityLineItemType:    { keyFields: ['id'] },
    ExceptionListItemType:   { keyFields: ['id'] },
    Document:                { keyFields: ['id'] },
    Study:                   { keyFields: ['id'] },
    Organization:            { keyFields: ['id'] },
    BankTransactionType:         { keyFields: ['id'] },
    BankTransactionDetailType:   { keyFields: ['id'] },
    BankTransactionListItemType: { keyFields: ['id'] },
    BankAccount:             { keyFields: ['id'] },
    RemittanceType:          { keyFields: ['id'] },
    RemittanceListItemType:  { keyFields: ['id'] },
    RemittanceLineItemType:  { keyFields: ['id'] },
    CollectionsActionType:   { keyFields: ['id'] },
    User:                    { keyFields: ['id'] },
    AuthUser:                { keyFields: ['id'] },
    SiteOrganizationType:    { keyFields: ['id'] },
    StudyProtocolAliasType:  { keyFields: ['id'] },
    ContractedRateType:      { keyFields: ['id'] },
    PerformanceEventType:    { keyFields: ['id'] },
    PatientType:             { keyFields: ['id'] },

    // Singleton/aggregate types — no id, do not normalize
    ReconciliationSummaryType: { keyFields: false },
    PaymentVelocityType:       { keyFields: false },
    CategoryBreakdownType:     { keyFields: false },
    OutstandingBreakdownType:  { keyFields: false },
    ArAgingMetricsType:        { keyFields: false },
    VelocityBucket:            { keyFields: false },
    InvoiceOverview:           { keyFields: false },
    ExceptionHealthType:       { keyFields: false },
    SystemHealthType:          { keyFields: false },
    ReviewQueueSummary:        { keyFields: false },
  },
});

// Create Apollo Client
const client = new ApolloClient({
  link: authLink.concat(uploadLink),
  cache,
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'all'
    },
    query: {
      errorPolicy: 'all'
    }
  }
});

export default client;